import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const ContactOptionsMenu = ({ user, onChangeResponsable }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleMenuClose = (e) => {
        e?.stopPropagation();
        setAnchorEl(null);
    };

    const handleChangeResponsable = (e) => {
        e.stopPropagation();
        if (onChangeResponsable) {
            onChangeResponsable(user);
        }
        handleMenuClose();
    };

    return (
        <>
            <IconButton
                size="small"
                onClick={handleMenuOpen}
                sx={{ color: "#aebac1" }}
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                sx={{ justifyContent: "flex-end", textAlign: "right" }}
                PaperProps={{
                    sx: {
                        bgcolor: "#233138",
                        borderRadius: "8px",
                        minWidth: "180px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                        "& .MuiMenuItem-root": {
                            fontSize: "0.9rem",
                            padding: "8px 16px",
                            "&:hover": {
                                bgcolor: "#2a3942"
                            }
                        }
                    }
                }}
            >
                <MenuItem onClick={handleChangeResponsable}>
                    <span style={{ color: "#fff" }}>Cambiar responsable</span>
                </MenuItem>
            </Menu>
        </>
    );
};
